"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Collapse: function() {
        return _Collapse.Collapse;
    },
    CollapseDelayed: function() {
        return _Collapse.CollapseDelayed;
    },
    CollapseRelaxed: function() {
        return _Collapse.CollapseRelaxed;
    },
    CollapseSnappy: function() {
        return _Collapse.CollapseSnappy;
    }
});
const _Collapse = require("./Collapse");
